import { LOG_DEBUG_MESSAGE } from "../actions";
import initialState from "./initialState";
import uuid from "../utils/uuid";
export default function debugMessages() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState.debugMessages, action = arguments.length > 1 ? arguments[1] : void 0;
    var nState = state.slice();
    switch(action.type){
        case LOG_DEBUG_MESSAGE:
            nState.push({
                id: uuid(),
                timestamp: new Date(),
                message: action.message,
                type: action.messageType || "info",
                label: action.label
            });
            return nState;
        default:
            return state;
    }
}
